import React, { useState, useEffect } from 'react';
import '../../src/styles/Quantity.css';

export const QuantityControl = ({
  quantity,
  incrementQuantity,
  decrementQuantity,
  buttonsDisabled,
  setQuantity,
  isLoadingInc,
  isLoadingDec,
}) => {
  const [inputValue, setInputValue] = useState(quantity.toString());
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    // Sync with external changes
    setInputValue(quantity.toString());
  }, [quantity]);

  // QuantityControl.jsx

  const handleChange = (e) => {
    const val = e.target.value;
    if (!/^\d*$/.test(val)) return; // Only allow numbers
    setInputValue(val);
    const num = parseInt(val, 10);
    if (!isNaN(num)) {
      setQuantity(num);
    }
  };

  const updateQuantityFromInput = () => {
    const num = parseInt(inputValue, 10);
    if (!isNaN(num) && num > 0) {
      setQuantity(num);
    } else {
      setQuantity(1);
      setInputValue("1");
    }
  };

  const handleBlur = () => {
    updateQuantityFromInput();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      updateQuantityFromInput();
      e.target.blur();
    }
  };

  const handleIncrement = () => {

    const current = parseInt(inputValue || "1", 10);
    const newValue = current + 1;
    setInputValue(newValue.toString());
    setQuantity(newValue);

  };

  const handleDecrement = () => {

    const current = parseInt(inputValue || "1", 10);
    const newValue = current - 1;
    setInputValue(newValue.toString());
    setQuantity(newValue);
  };

  return (
    <div className="d-flex rounded-4 overflow-hidden">
      {/* Decrement Button */}
      <button
        onClick={handleDecrement}
        disabled={buttonsDisabled || isLoadingDec}
        className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
        style={{ borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px" }}
      >
        {isLoadingDec ? (
          <span className="spinner-border spinner-border-sm" />
        ) : (
          <div>-</div>
        )}
      </button>

      {/* Input Field */}
      <input
        type="text"
        className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-4"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      />

      {/* Increment Button */}
      <button
        onClick={handleIncrement}
        disabled={buttonsDisabled || isLoadingInc}
        className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-48 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
        style={{ borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }}
      >
        {isLoadingInc ? (
          <span className="spinner-border spinner-border-sm" />
        ) : (
          <i className="ph ph-plus" />
        )}
      </button>
    </div>
  );
};

export const QuantityControlQty = ({
  quantity,
  incrementQuantity,
  decrementQuantity,
  buttonsDisabled,
  setQuantity,
  isLoadingInc,
  isLoadingDec,
}) => {
  const [inputValue, setInputValue] = useState(quantity.toString());

  useEffect(() => {
    setInputValue(quantity.toString());
  }, [quantity]);


const handleChange = (e) => {
  const val = e.target.value;
  if (!/^\d*$/.test(val)) return;
  setInputValue(val);
};


const updateQuantityFromInput = () => {
  const num = Number(inputValue);

  if (Number.isNaN(num)) {
    setInputValue(quantity.toString());
    return;
  }
  setQuantity(num);

  if (num < quantity) {
    setInputValue(quantity.toString());
  }
};


  const handleBlur = () => {
    updateQuantityFromInput();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      updateQuantityFromInput();
      e.target.blur();
    }
  };


  return (
    <div className="d-flex rounded-4 overflow-hidden">
      {/* Decrement Button */}
      <button
        onClick={decrementQuantity}
        disabled={buttonsDisabled || isLoadingDec}
        className="quantity__minus border border-end border-gray-100 flex-shrink-0 h-30 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
        style={{ borderTopLeftRadius: "8px", borderBottomLeftRadius: "8px" }}
      >
        {isLoadingDec ? (
          <span className="spinner-border spinner-border-sm" />
        ) : (
          <div>-</div>
        )}
      </button>

      {/* Input Field */}
      <input
        type="text"
        className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-3 px-4"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
      
      />

      {/* Increment Button */}
      <button
        onClick={incrementQuantity  }
        disabled={buttonsDisabled || isLoadingInc}
        className="quantity__plus border border-end border-gray-100 flex-shrink-0 h-0 w-48 text-neutral-600 flex-center hover-bg-main-600 hover-text-white"
        style={{ borderTopRightRadius: "8px", borderBottomRightRadius: "8px" }}
      >
        {isLoadingInc ? (
          <span className="spinner-border spinner-border-sm" />
        ) : (
          <i className="ph ph-plus" />
        )}
      </button>
    </div>
  );
};

 




